export default "__VITE_ASSET__41f88a1b__"